<template>
  <div>
    <Row class="m-b-5">
      <i-col flex="100px" class="text-14">收款单附件</i-col>
      <i-col flex="100px">
        <Upload
          :action="uploadUrl"
          :headers="uploadHeaders"
          :data="uploadParams"
          :show-upload-list="false"
          :disabled="beginUploading"
          :before-upload="handleBeforeUpload"
          :on-success="onExportSuccess">
            <Button type="success" size="small" icon="ios-cloud-upload-outline">点击上传附件</Button>
        </Upload>
      </i-col>
    </Row>

    <Table :columns="fileColumns" :loading="beginUploading" stripe size="small" :data="fileList"></Table>
  </div>
</template>

<script>
// utils
import { getStorage } from '@/utils/storage'
import { downloadFileRequest } from '@/utils/download'
// apis
import { getFileList } from '@/api/invest/electricAttachFile'

export default {
  props: {},
  data () {
    return {
      uploadUrl: process.env.VUE_APP_API_URL_V2 + '/ooh-invest/electricAttachFile/uploadFile',
      uploadHeaders: {
        'ooh-auth': getStorage('ooh-token')
      },

      uploadParams: null,
      beginUploading: false,
      fileList: [],
      fileColumns: [
        { title: '文件名称', dataIndex: 'fileName', key: 'fileName' },
        { title: '文件类型', dataIndex: 'mimeType', key: 'mimeType' },
        {
          title: '文件大小',
          render: (h, params) => {
            return h('span', params.row.length + ' KB')
          }
        },
        { title: '上传时间', dataIndex: 'createTime', key: 'createTime' },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          render: (h, params) => {
            const detailButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleDownload(params.row)
                  }
                }
              },
              '下载'
            )
            const returnBtns = []

            returnBtns.push(detailButton)
            return h('div', returnBtns)
          }
        }
      ]
    }
  },
  mounted () {},
  created () {},
  methods: {
    initPageData (billId) {
      this.uploadParams = { billId: billId }

      getFileList({ billId: billId }).then(res => {
        this.fileList = res
      })
    },
    handleBeforeUpload () {
      this.beginUploading = true
    },
    onExportSuccess (res) {
      this.beginUploading = false
      this.initPageData(this.uploadParams.billId)
    },
    handleDownload (params) {
      const fileName = params.fileName
      const query = {
        fileId: params.id
      }

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-invest/electricAttachFile/downloadFile', query, fileName)
    }
  }
}
</script>
